import React, { useState, useEffect } from "react";


import AttendeesList from "./AttenteesList"
import AddAttendeeModal from "./AddAttendeeModal"
import { Link } from "react-router-dom"
import axios from "axios"
import { localserver } from "../../../api/common"
import { showToast, ToastMessage } from "../../Shared/ToastMessage"
import { useUser } from "../../AdminUsers/UserContext"
import { FaChevronRight, FaUserPlus, FaUsers, FaFilter } from "react-icons/fa"
import { useEvent } from '../../Event/EventContext';
const EventAttendees = () => {

  const { checkPermission } = useUser()
  const { eventName, eventStatus, fetchEventDetails, updateEventStatus } = useEvent();
  const [isSearchbar, toggleSearchBar] = useState(false)
  const [showAddModal, setShowAddModal] = useState(false)
  const [attendeesList, setAttendeesList] = useState([])
  const [attendeesListSummary, setAttendeesListSummary] = useState([])
  const [ticketList, setTicketList] = useState([])
  const [buyerForm, setBuyerForm] = useState([])
  const [ticketSetting, setTicketSetting] = useState({})
  const [eventCountList, setEventCountList] = useState({})

  // Filter states
  const [selectedTicket, setSelectedTicket] = useState("0")
  const [dateFrom, setDateFrom] = useState("")
  const [dateTo, setDateTo] = useState("")

  const getAttendeesByEventID = async (params = {}, setList = true) => {
    const { ticket_id = "0", from_date = "", to_date = "", search = "", status = "all" } = params
    try {
      const response = await axios.post(
        `${localserver}/attendee_by_event_id`,
        {
          event_id: localStorage.getItem("eventId"),
          status,
          ...(ticket_id !== "0" && { ticket_id }),
          from_date,
          to_date,
          search,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        },
      )
      if (response.data.success) {
        if (setList) {
          setAttendeesList(response.data.attendees || [])
        }
        setEventCountList(response.data.main_details || {})
        if (status === "all") {
          setAttendeesListSummary(response.data.statusSummary || [])
        }
      } else {
        console.error("Error: Failed to fetch event data")
      }
    } catch (error) {
      console.error("Error fetching event data:", error)
    }
  }

  const updateAttendeeStatus = async (attendee_id, status) => {
    try {
      const response = await axios.post(
        `${localserver}/update_attendee_status`,
        {
          attendee_id,
          event_id: localStorage.getItem("eventId"),
          status,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        },
      )
      if (response.data.success) {
        showToast(response.data.message, "success")
        getAttendeesByEventID({ status: "all" }, false)
        return true
      } else {
        console.error("Error: Failed to update attendee status", response.data.message)
        showToast(response.data.message, "error")
        return false
      }
    } catch (error) {
      console.error("Error updating attendee status:", error)
      return false
    }
  }

  const resendSuccessMail = async (attendee_id) => {
    try {
      const response = await axios.post(
        `${localserver}/resend_success_mail`,
        {
          attendee_id,
          event_id: localStorage.getItem("eventId"),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        },
      )
      if (response.data.success) {
        showToast(response.data.message, "success")
        return true
      } else {
        console.error("Error: Failed to update attendee status")
        showToast(response.data.message, "error")
        return false
      }
    } catch (error) {
      console.error("Error updating attendee status:", error)
      showToast(error, "error")
      return false
    }
  }

  const getTicketsByEventID = async () => {
    try {
      const response = await axios.post(
        `${localserver}/get_ticket_by_event_id`,
        {
          event_id: localStorage.getItem("eventId"),
          ticket_status: "all",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        },
      )
      if (response.data.success) {
        setTicketList(response.data.tickets || [])
        setBuyerForm(response.data.buyerFormData || [])
        setTicketSetting(response.data.settings[0] || {})
      } else {
        console.error("Error: Failed to fetch event data")
      }
    } catch (error) {
      console.error("Error fetching event data:", error)
    }
  }

  const handleCreateAttendee = async () => {
    const hasPermission = await checkPermission("Attendees", "create")
    if (!hasPermission) return
    setShowAddModal(true)
  }

  const handleShowAddAttendeeModal = (status) => {
    setShowAddModal(status)
  }

  const handleFilterChange = () => {
    getAttendeesByEventID({
      ticket_id: selectedTicket,
      from_date: dateFrom,
      to_date: dateTo,
      status: "all",
    })
  }

  const handleResetFilters = () => {
    setSelectedTicket("0")
    setDateFrom("")
    setDateTo("")
    getAttendeesByEventID({ status: "all" })
  }

  const [checkUserLoading, setCheckUserLoading] = useState(false)
  const fetchPermission = async () => {
    setCheckUserLoading(true)
    try {
      const hasPermission = await checkPermission("Attendees", "view")
      if (!hasPermission) return
    } catch (error) {
      console.error("Error Check Permission:", error)
    } finally {
      setCheckUserLoading(false)
    }
  }

  useEffect(() => {
    fetchPermission()
  }, [])

  useEffect(() => {
    let isMounted = true
    const fetchData = async () => {
      try {
        await Promise.all([getAttendeesByEventID({ status: "all" }, false), getTicketsByEventID()])
      } catch (error) {
        console.error("Error fetching initial data:", error)
      }
    }

    fetchData()

    return () => {
      isMounted = false
    }
  }, [])


  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <ToastMessage />
      <div className={`overlay ${isSearchbar ? "active" : ""}`} onClick={() => toggleSearchBar(false)}></div>
      {checkUserLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          <div
            style={{
              width: "48px",
              height: "48px",
              border: "4px solid #e5e7eb",
              borderTop: "4px solid #184778",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          ></div>
          <span style={{ color: "#6b7280", fontSize: "16px" }}>Loading attendees...</span>
          <style>
            {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
          </style>
        </div>
      ) : (
        <div style={{ minHeight: "100vh", backgroundColor: "#f9fafb", padding: "24px 15px " }}>
          <div  >
            {/* Header Section */}
            <div style={{ marginBottom: "22px" }}>
              <div
                className="brood_comes_div"
              >
                <div className="row align-items-center">
                  <div className="col-md-6 brood_comes_heading">
                    <h2  >
                      <div className="brood_comes_part">
                        <FaUsers size={20} />
                      </div>
                      Event Attendees
                    </h2>
                    {/* <nav aria-label="breadcrumb">
                      <ol
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          listStyle: "none",
                          padding: 0,
                          margin: 0,
                          fontSize: "14px",
                        }}
                      >
                        <li>
                          <Link
                            to="/events/admin/"
                            style={{
                              color: "#6b7280",
                              textDecoration: "none",
                              transition: "color 0.2s ease",
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.color = "#184778")}
                            onMouseLeave={(e) => (e.currentTarget.style.color = "#6b7280")}
                          >
                            AMASI
                          </Link>
                        </li>
                        <li style={{ color: "#d1d5db" }}>
                          <FaChevronRight size={10} />
                        </li>
                        <li style={{ color: "#184778", fontWeight: "500" }}>Attendees</li>
                      </ol>
                    </nav> */}
                  </div>

                  <div className="col-md-6 text-end">
                    <button
                      onClick={() => handleCreateAttendee()}
                      disabled={eventStatus !== "published"}
                      title={eventStatus !== "published" ? "Only add attendees to published events" : ""}
                      style={{
                        background: eventStatus !== "published" ? "#ccc" : "#184778",
                        color: eventStatus !== "published" ? "#666" : "#ffffff",
                        border: "none",
                        borderRadius: "8px",
                        padding: "10px 20px",
                        fontSize: "14px",
                        fontWeight: "600",
                        cursor: eventStatus !== "published" ? "not-allowed" : "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        transition: "all 0.3s ease",
                        boxShadow: eventStatus !== "published" ? "none" : "0 2px 4px rgba(24, 71, 120, 0.2)",
                        opacity: eventStatus !== "published" ? 0.6 : 1,
                      }}
                      onMouseEnter={(e) => {
                        if (eventStatus !== "published") return;
                        e.currentTarget.style.background = "#0f3a5f"
                        e.currentTarget.style.transform = "translateY(-2px)"
                        e.currentTarget.style.boxShadow = "0 4px 8px rgba(24, 71, 120, 0.3)"
                      }}
                      onMouseLeave={(e) => {
                        if (eventStatus !== "published") return;
                        e.currentTarget.style.background = "#184778"
                        e.currentTarget.style.transform = "translateY(0)"
                        e.currentTarget.style.boxShadow = "0 2px 4px rgba(24, 71, 120, 0.2)"
                      }}
                    >
                      <FaUserPlus size={16} />
                      Add Attendees
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Filter Section */}
            {/* <div style={{ marginBottom: "22px" }}>


              <div className='filter_div_card' >
                <div className='filter_option_div'  >
                  <FaFilter />
                  <h3   >Filter Attendees</h3>
                </div>

                <div className="row g-3 align-items-end">
                  <div className="col-md-3">
                    <label
                      htmlFor="ticketType"
                      style={{
                        display: "block",
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#374151",
                        marginBottom: "8px",
                      }}
                    >
                      Ticket Type:
                    </label>
                    <select
                      id="ticketType"
                      value={selectedTicket}
                      onChange={(e) => setSelectedTicket(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "10px 12px",
                        fontSize: "14px",
                        border: "1px solid #d1d5db",
                        borderRadius: "8px",
                        backgroundColor: "white",
                        color: "#374151",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                      }}
                      onFocus={(e) => {
                        e.currentTarget.style.borderColor = "#184778"
                        e.currentTarget.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                      }}
                      onBlur={(e) => {
                        e.currentTarget.style.borderColor = "#d1d5db"
                        e.currentTarget.style.boxShadow = "none"
                      }}
                    >
                      <option value="0">All Tickets</option>
                      {ticketList.map((ticket) => (
                        <option key={ticket.id} value={ticket.id}>
                          {ticket.ticket_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-3">
                    <label
                      htmlFor="dateFrom"
                      style={{
                        display: "block",
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#374151",
                        marginBottom: "8px",
                      }}
                    >
                      Registration From:
                    </label>
                    <input
                      id="dateFrom"
                      type="date"
                      value={dateFrom}
                      onChange={(e) => setDateFrom(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "10px 12px",
                        fontSize: "14px",
                        border: "1px solid #d1d5db",
                        borderRadius: "8px",
                        backgroundColor: "white",
                        color: "#374151",
                        transition: "all 0.2s ease",
                      }}
                      onFocus={(e) => {
                        e.currentTarget.style.borderColor = "#184778"
                        e.currentTarget.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                      }}
                      onBlur={(e) => {
                        e.currentTarget.style.borderColor = "#d1d5db"
                        e.currentTarget.style.boxShadow = "none"
                      }}
                    />
                  </div>

                  <div className="col-md-3">
                    <label
                      htmlFor="dateTo"
                      style={{
                        display: "block",
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#374151",
                        marginBottom: "8px",
                      }}
                    >
                      Registration To:
                    </label>
                    <input
                      id="dateTo"
                      type="date"
                      value={dateTo}
                      onChange={(e) => setDateTo(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "10px 12px",
                        fontSize: "14px",
                        border: "1px solid #d1d5db",
                        borderRadius: "8px",
                        backgroundColor: "white",
                        color: "#374151",
                        transition: "all 0.2s ease",
                      }}
                      onFocus={(e) => {
                        e.currentTarget.style.borderColor = "#184778"
                        e.currentTarget.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                      }}
                      onBlur={(e) => {
                        e.currentTarget.style.borderColor = "#d1d5db"
                        e.currentTarget.style.boxShadow = "none"
                      }}
                    />
                  </div>

                  <div className="col-md-3">
                    <div style={{ display: "flex", gap: "8px" }}>
                      <button
                        onClick={handleFilterChange}
                        className='apply_btn btn'
                      >
                        Apply
                      </button>
                      <button
                        onClick={handleResetFilters}
                        className="reset_btn btn"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>




            </div> */}


            <div style={{ marginBottom: "22px" }}>
              <div className="filter_div_card">
                {/* Accordion Header */}
                <div
                  className="filter_option_div"
                  onClick={() => setIsOpen(!isOpen)}
                  style={{
                    cursor: "pointer",
                    userSelect: "none",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <FaFilter />
                    <h3>Filter Attendees</h3>
                  </div>
                  <span
                    style={{
                      fontSize: "18px",
                      transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                      color: "#184778",
                    }}
                  >
                    <i class="fa fa-angle-down"></i>
                  </span>
                </div>

                {/* Accordion Content */}
                <div
                  className={`accordion-content ${isOpen ? "open" : ""}`}
                  style={{
                    maxHeight: isOpen ? "400px" : "0",
                    overflow: "hidden",
                    transition: "max-height 0.4s ease, opacity 0.3s ease",
                    opacity: isOpen ? 1 : 0,
                  }}
                >
                  <div className="row g-3 align-items-end" style={{ marginTop: "10px" }}>
                    <div className="col-md-3">
                      <label
                        htmlFor="ticketType"
                        style={{
                          display: "block",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#374151",
                          marginBottom: "8px",
                        }}
                      >
                        Ticket Type:
                      </label>
                      <select
                        id="ticketType"
                        value={selectedTicket}
                        onChange={(e) => setSelectedTicket(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "10px 12px",
                          fontSize: "14px",
                          border: "1px solid #d1d5db",
                          borderRadius: "8px",
                          backgroundColor: "white",
                          color: "#374151",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                        onFocus={(e) => {
                          e.currentTarget.style.borderColor = "#184778"
                          e.currentTarget.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                        }}
                        onBlur={(e) => {
                          e.currentTarget.style.borderColor = "#d1d5db"
                          e.currentTarget.style.boxShadow = "none"
                        }}
                      >
                        <option value="0">All Tickets</option>
                        {ticketList
                          .filter((ticket) => ticket.ticket_status === "onsale")
                          .map((ticket) => (
                            <option key={ticket.id} value={ticket.id}>
                              {ticket.ticket_name}
                            </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label
                        htmlFor="dateFrom"
                        style={{
                          display: "block",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#374151",
                          marginBottom: "8px",
                        }}
                      >
                        Registration From:
                      </label>
                      <input
                        id="dateFrom"
                        type="date"
                        value={dateFrom}
                        onChange={(e) => setDateFrom(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "10px 12px",
                          fontSize: "14px",
                          border: "1px solid #d1d5db",
                          borderRadius: "8px",
                          backgroundColor: "white",
                          color: "#374151",
                          transition: "all 0.2s ease",
                        }}
                        onFocus={(e) => {
                          e.currentTarget.style.borderColor = "#184778"
                          e.currentTarget.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                        }}
                        onBlur={(e) => {
                          e.currentTarget.style.borderColor = "#d1d5db"
                          e.currentTarget.style.boxShadow = "none"
                        }}
                      />
                    </div>

                    <div className="col-md-3">
                      <label
                        htmlFor="dateTo"
                        style={{
                          display: "block",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#374151",
                          marginBottom: "8px",
                        }}
                      >
                        Registration To:
                      </label>
                      <input
                        id="dateTo"
                        type="date"
                        value={dateTo}
                        onChange={(e) => setDateTo(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "10px 12px",
                          fontSize: "14px",
                          border: "1px solid #d1d5db",
                          borderRadius: "8px",
                          backgroundColor: "white",
                          color: "#374151",
                          transition: "all 0.2s ease",
                        }}
                        onFocus={(e) => {
                          e.currentTarget.style.borderColor = "#184778"
                          e.currentTarget.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)"
                        }}
                        onBlur={(e) => {
                          e.currentTarget.style.borderColor = "#d1d5db"
                          e.currentTarget.style.boxShadow = "none"
                        }}
                      />
                    </div>

                    <div className="col-md-3">
                      <div style={{ display: "flex", gap: "8px" }}>
                        <button
                          onClick={handleFilterChange}
                          className='apply_btn btn'
                        >
                          Apply
                        </button>
                        <button
                          onClick={handleResetFilters}
                          className="reset_btn btn"
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Attendees List Content */}
            <AttendeesList
              attendeesList={attendeesList}
              updateAttendeeStatus={updateAttendeeStatus}
              resendSuccessMail={resendSuccessMail}
              getAttendeesByEventID={getAttendeesByEventID}
              ticketList={ticketList}
              eventCountList={eventCountList}
              attendeesListSummary={attendeesListSummary}
            />
          </div>
        </div>
      )}
      <AddAttendeeModal
        ticketList={ticketList}
        buyerForm={buyerForm}
        settingsDetails={ticketSetting}
        show={showAddModal}
        onHide={() => handleShowAddAttendeeModal(false)}
        getAttendeesByEventID={getAttendeesByEventID}
      />
    </>
  )
}

export default EventAttendees
